/*
    This will be the new location for format mask constants used in InputMask.
    mask = the actual mask used for InputMask (required)
    placeholder = text to show the user as they type. Must be same length as mask. (optional)
    momentjs = Required if the mask is going to be used in DateInput. otherwise (optional)
 */

export default {
    "armus_date_year" : {
        mask : "YYYY",
        placeholder : "yyyy",
        momentjs: "YYYY",
    },
    "armus_date_month" :{
        mask: "MM/YYYY",
        placeholder : "mm/yyyy",
        momentjs: "MM/YYYY",
    },
    "armus_date_day" : {
        mask : "MM/DD/YYYY",
        placeholder : "mm/dd/yyyy",
        momentjs: "MM/DD/YYYY"
    },
    "armus_datetime_hour" : {
        mask : "MM/DD/YYYY HH",
        placeholder : "mm/dd/yyyy hh",
        momentjs: "MM/DD/YYYY HH"
    },
    "armus_datetime_minute" : {
        mask : "MM/DD/YYYY HH:mm",
        placeholder : "mm/dd/yyyy hh:mm",
        momentjs: "MM/DD/YYYY HH:mm",
    },
    "armus_datetime_second" : {
        mask : "MM/DD/YYYY HH:mm:ss",
        placeholder : "mm/dd/yyyy hh:mm:ss",
        momentjs: "MM/DD/YYYY HH:mm:ss",
    },
    "armus_time_hour" : {
        mask : "HH",
        placeholder : "hh",
        momentjs: "HH",
    },
    "armus_time_minute" : {
        mask : "HH:mm",
        placeholder : "hh:mm",
        momentjs: "HH:mm"
    },
    "armus_time_second" : {
        mask : "HH:mm:ss",
        placeholder : "hh:mm:ss",
        momentjs: "HH:mm:ss",
    }
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/InputMask/MaskConstants.js